export const getLogoBaseUrl = (filename) => `https://www.haven.com/assets/logos/${filename}`;
export const getIconBaseUrl = (filename) => `https://www.haven.com/assets/icons/${filename}`;
export default {
    getLogoBaseUrl,
    getIconBaseUrl,
};
